import { Middleware } from "redux";

import { Commands } from "@com.mgmtp.a12.formengine/formengine-core/lib/back-end/store";
import {
	FormActivity,
	FormEngineActions,
	FormEngineSelectors
} from "@com.mgmtp.a12.formengine/formengine-core/lib/client-extensions";
import { Locale } from "@com.mgmtp.a12.utils/utils-localization/lib/main";
import { DocumentModel, DocumentServiceFactory, GroupInstance } from "@com.mgmtp.a12.kernel/kernel-md-facade";
import { ActivityActions, ActivitySelectors } from "@com.mgmtp.a12.client/client-core/lib/core/activity";

import { assertNonNullable, assertTrue } from "../../../utilities/assert";
import { isGroupInstanceArray } from "../../../utilities/documentHelpers";

import SingleDocumentData = FormActivity.Data.SingleDocumentData;

const FILE_UPLOAD_SUFFIX = "file_upload";
const CREATED_AT_FIELD_NAME = "uploadDatum";
export const setAttachmentUploadDateMiddleware: Middleware<unknown, { locale: Locale }> = api => next => action => {
	const result = next(action);

	if (
		FormEngineActions.command.match(action) &&
		Commands.changeRepeatInstanceStateEntry.match(action.payload.engineEvent) &&
		action.payload.engineEvent.payload.entry.newRow?.rowPath
			.map(it => it.elementName)
			.join("/")
			.endsWith("/" + FILE_UPLOAD_SUFFIX) &&
		action.payload.engineEvent.payload.entry.newRow?.rowState === "recentlyAdded"
	) {
		const documentService = new DocumentServiceFactory().getDocumentService();
		const activityData = ActivitySelectors.data(action.payload.activityId)(api.getState());
		assertTrue(SingleDocumentData.isInstance(activityData));

		const engineState = FormEngineSelectors.engineState(action.payload.activityId)(api.getState());
		assertNonNullable(engineState);

		const documentModel = engineState.models.documentModel;

		const createdAtFieldPath = [
			...action.payload.engineEvent.payload.entry.newRow.rowPath.slice(undefined, -1),
			{ elementName: FILE_UPLOAD_SUFFIX, index: 0 },
			{ elementName: CREATED_AT_FIELD_NAME, index: 1 }
		];

		if (getElement(documentModel, createdAtFieldPath)) {
			const groupInstances = documentService.getAssignedObject(activityData.document, [
				...action.payload.engineEvent.payload.entry.newRow.rowPath.slice(undefined, -1),
				{ elementName: FILE_UPLOAD_SUFFIX, index: 0 }
			]);
			assertTrue(isGroupInstanceArray(groupInstances));

			let updatedDocument = activityData.document as GroupInstance;
			for (let i = 0; i < groupInstances.length; i++) {
				if (!groupInstances[i][CREATED_AT_FIELD_NAME]) {
					updatedDocument = documentService.updateEntityInstance(
						updatedDocument,
						[
							...action.payload.engineEvent.payload.entry.newRow.rowPath.slice(undefined, -1),
							{ elementName: FILE_UPLOAD_SUFFIX, index: i + 1 },
							{ elementName: CREATED_AT_FIELD_NAME, index: 1 }
						],
						new Date(),
						documentModel
					);
				}
			}

			api.dispatch(
				ActivityActions.setData({
					data: { ...activityData, document: updatedDocument },
					activityId: action.payload.activityId
				})
			);
		}
	}

	return result;
};

function getElement(documentModel: DocumentModel, createdAtFieldPath: any[]) {
	return new DocumentServiceFactory()
		.getDocumentModelSearchService(documentModel)
		.getByPath(createdAtFieldPath.map(it => ({ elementName: it.elementName })));
}
